import { createClient } from 'urql';
import { OV_GRAPHQL_URL } from '../config/theme';

var graphqlClient = function graphqlClient(urlParams) {
  var client = createClient({
    url: OV_GRAPHQL_URL,
    fetchOptions: function fetchOptions() {
      var purge = urlParams.get('purge') === '1';
      return purge ? {
        headers: {
          'x-ov-purge': '1'
        }
      } : {};
    }
  });
  return client;
};

export default graphqlClient;